import { RemoveCircleOutline, AddCircleOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';

interface Props {
  pUsers: Record<string, string>;
  addUser: (_userId: string, _email: string) => void;
  blockUser: (_userId: string) => void;
}
export const PermittedUsers: React.FC<Props> = ({ pUsers, blockUser, addUser }) => {
  const [userId, setUserId] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  const add = () => {
    addUser(userId, email);
    setUserId('');
    setEmail('');
  };
  return (
    <div className="flex flex-col w-[40rem] gap-1">
      {Object.entries(pUsers).map(([key, user], i) => (
        <div key={i} className="flex gap-2 border-t border-gray-110 justify-between items-center">
          <p>{key}</p>-<p>{user}</p>
          <p className="cursor-pointer">
            <Button onClick={() => blockUser(key)}>
              <RemoveCircleOutline />
            </Button>
          </p>
        </div>
      ))}
      <div className="flex gap-2 justify-between items-center">
        <p>
          <input
            className="border border-gray-100 w-72"
            value={userId}
            onChange={({ target }) => setUserId(target.value)}
          />
        </p>
        -
        <p>
          <input className="border border-gray-100" value={email} onChange={({ target }) => setEmail(target.value)} />
        </p>
        <p>
          <Button onClick={add}>
            <AddCircleOutline />
          </Button>
        </p>
      </div>
    </div>
  );
};
